import { Map as IMap } from 'immutable';
import {
    NEARMAP_COVERAGE,
    NEARMAP_COVERAGE_SUCCESS,
    NEARMAP_COVERAGE_FAIL,
    SET_SELECTED_NEARMAP_COVERAGE,
    CLEAR_NEARMAP_COVERAGE,
    AUCKLAND_FLOOD_GEOJSON_SUCCESS,
    SET_EXPAND_MAP_FOR_HAZARDS,
    SAVE_DRAWINGS,
    SET_EMPTY_MAP_BUBBLE,
    CLEAR_DRAWINGS,
} from '../actions/map';
import {
    CLAPI_CLEAR_PROPERTY,
    GET_PARTIAL_PROPERTY_DETAILS
} from '../actions/clapi';

export const initialState = IMap({
    nearmap: {
        coverage: null,
        selectedCoverage: null,
        coverageFetching: false,
    },
    aucklandFloodGeoJson: {
        geoJson: null,
    },
    openExpandMapForHazards: false,
    emptyMapBubble: null,
});

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case NEARMAP_COVERAGE:
            return state.merge(IMap({
                nearmap: {
                    ...state.get('nearmap'),
                    coverageFetching: true,
                },
            }));
        case NEARMAP_COVERAGE_FAIL: case CLEAR_NEARMAP_COVERAGE:
            return state.merge(IMap({
                nearmap: {
                    ...state.get('nearmap'),
                    coverage: null,
                    coverageFetching: false,
                },
            }));
        case NEARMAP_COVERAGE_SUCCESS:
            return state.merge(IMap({
                nearmap: {
                    ...state.get('nearmap'),
                    coverage: action.payload.coverage,
                    coverageFetching: false,
                },
            }));
        case AUCKLAND_FLOOD_GEOJSON_SUCCESS:
            return state.merge(IMap({
                aucklandFloodGeoJson: {
                    geoJson: action.payload,
                },
            }));
        case SET_SELECTED_NEARMAP_COVERAGE:
            return state.merge(IMap({
                nearmap: {
                    ...state.get('nearmap'),
                    selectedCoverage: action.payload.selected,
                },
            }));
        case SAVE_DRAWINGS: {
            return state.merge(IMap({
                drawings: action.payload,
            }));
        }
        case CLEAR_DRAWINGS: {
            return state.merge(IMap({
                drawings: null,
            }));
        }
        case SET_EMPTY_MAP_BUBBLE: {
            return state.merge(IMap({
                emptyMapBubble: action.payload,
            }));
        }
        case CLAPI_CLEAR_PROPERTY:
        case GET_PARTIAL_PROPERTY_DETAILS:
            return IMap(initialState);
        case SET_EXPAND_MAP_FOR_HAZARDS:
            return state.merge(IMap({
                openExpandMapForHazards: action.payload
            }));
        default: return state;
    }
}
